"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_webview_1 = __importDefault(require("react-native-webview"));
const WebViewer = ({ docSrc, windowHeight = '100%' }) => {
    let src = docSrc;
    if (react_native_1.Platform.OS !== 'web') {
        if (src) {
            if (src.split('.pdf').length === 2) {
                src = `https://docs.google.com/gview?embedded=true&url=${docSrc}`;
            }
        }
        else {
            src = '';
        }
    }
    else {
        src = `https://docs.google.com/gview?embedded=true&url=${docSrc}`;
    }
    let iframeGlobal = react_1.default.createElement(react_native_webview_1.default, { source: { uri: src }, startInLoadingState: true, scalesPageToFit: true });
    if (react_native_1.Platform.OS === 'web') {
        const iframeStyle = { height: '100%' };
        iframeGlobal = react_1.default.createElement("iframe", { title: "webIFrame", src: src, style: iframeStyle });
    }
    return react_1.default.createElement(react_native_1.View, { style: { height: windowHeight } }, iframeGlobal);
};
exports.default = WebViewer;
